import React from 'react';
import {
    Stat as ChakraStat,
    StatLabel,
    StatNumber,
    BoxProps
} from '@chakra-ui/react';

type StatProps = { label: string } & BoxProps;

export const Stat: React.FC<StatProps> = ({ label, children, ...rest }) => {
    return (
        <ChakraStat {...rest}>
            <StatLabel color="gray.600">{label}</StatLabel>
            {typeof children === 'object' ? (
                children
            ) : (
                <StatNumber fontSize="sm">{children}</StatNumber>
            )}
        </ChakraStat>
    );
};
